import { defineStore } from 'pinia';
import HiCache from 'utils/cache';
import {
    betItemsType,
    BettingListTYpe,
    BettingOutrightListType,
    countryListType,
    HallListType,
    HotPlayListType,
    HotSportListType,
    IRecordList,
    ISubtotal,
    LeagueListType,
    OddsListType,
    OfficialSportTypeEnumType,
    OutrightCollectListType,
    OutrightOddsListType,
    OutrightPlayListType,
    PlayListType,
    ShowBettingListType,
    sportConfigType,
    SportListType,
    WsSportGoal,
    WsSportHandicap,
    WsSportLayout,
    WsSportOdds,
    WsSportSound,
    WsSportSoundType,
} from 'types/wsSportType';
import {
    findBetRecordAll,
    findBetRecordByStatus,
    findChampionFavoritesMatchList,
    findCountryList,
    findFavoritesMatchList,
    findHotList,
    findLeagueList,
    findLocationLeagueList,
    findMatchDetail,
    findMatchList,
    findOutrightInfo,
    findOutrightLeagueList,
    findOutrightLocationList,
    findPlayOdds,
    findResultDetail,
    findResultPage,
    findSingleLeagueList,
    findSportConfig,
    setConfig,
} from 'service/wsSport';
import usePrecision from 'core/hooks/usePrecision';
import { setGridStyle, transformDetailList, transformOddsGroupByList } from 'utils/sportInit';

const { getTimes, getMinus, toFixedTwoNum } = usePrecision();
import { useUserStore } from 'store/modules/userStore';

export interface WsLotteryState {
    // 页面布局 国际版 or 亚洲版
    sportLayout: WsSportLayout;
    // 盘口设置
    sportHandicap: WsSportHandicap;
    // 赔率设置 自动接收更好赔率 or 自动接收任何赔率变动 or 永远不会接收赔率变动
    sportOdds: WsSportOdds;
    // 足球进球推送 我的收藏赛事 or 我的投注赛事 or 全部足球赛事
    sportGoal: WsSportGoal[];
    sportSound: WsSportSoundType[];
    // 进球推送音乐
    /// 是否开启足球进球推送
    sportBallGoalNotice: boolean;
    sportHeaderScrollLeft: number;
    // 默认选中的提示音
    defaultSound: number;

    // 游戏类型
    OfficialSportTypeEnum: OfficialSportTypeEnumType[];
    resultList: [];
    countryList: countryListType[];
    leagueList: countryListType[];
    // 当前选中的游戏类型
    selectedSportType: OfficialSportTypeEnumType;
    // 大厅列表
    matchList: HallListType[];
    activeSport: string[];
    bettingSport: BettingListTYpe[] | BettingOutrightListType[];
    activeMatchDetail: SportListType;
    betMode: number; // 是否串关 1否 2是
    betModeMoney: string; // 是否串关 1否 2是
    canWinMoney: number | string; // 可赢金额
    collectList: number[]; // 赛事收藏列表
    outrightCollectList: number[]; // 冠军收藏列表
    outrightList: OutrightPlayListType[]; // 冠军详情列表
    singleMatchList: HallListType[];
    isShowCompare: boolean; // 是否接收更变
    hotMatchDetail: HotSportListType[]; // 热门
    isShowBetting: boolean; // 是否显示购物车
    showBettingList: ShowBettingListType | {};
    sportRecordObj: {
        // 投注记录
        [key: string]: {
            records: IRecordList[];
            total: number;
            subTotal: ISubtotal;
        };
    };
    sportRecordTabStatus: number;
    showList: any[];
}

export const useWsSportStore = defineStore('wsSport', {
    state: (): WsLotteryState => {
        return {
            sportLayout: HiCache.getCache<WsSportLayout>('sportLayout') || WsSportLayout.Asia,
            sportHandicap: HiCache.getCache<WsSportHandicap>('sportHandicap') || WsSportHandicap.Europe,
            sportOdds: HiCache.getCache<WsSportOdds>('sportOdds') || WsSportOdds.Better,
            sportGoal: HiCache.getCache<WsSportGoal[]>('sportGoal') || [WsSportGoal.Collect, WsSportGoal.Bet],
            sportBallGoalNotice: JSON.parse(HiCache.getCache<string>('sportBallGoalNotice')) ?? true,
            sportHeaderScrollLeft: 0,
            OfficialSportTypeEnum: [],
            selectedSportType: {},
            resultList: [],
            countryList: [],
            leagueList: [],
            matchList: [],
            activeSport: [],
            bettingSport: [],
            activeMatchDetail: {} as SportListType,
            betMode: 1,
            betModeMoney: '',
            canWinMoney: '',
            collectList: (HiCache.getCache<string[]>('collectList') && JSON.parse(HiCache.getCache<string>('collectList'))) || [],
            outrightCollectList: (HiCache.getCache<string[]>('outrightCollectList') && JSON.parse(HiCache.getCache<string>('outrightCollectList'))) || [],
            outrightList: [],
            singleMatchList: [],
            isShowCompare: false, // 是否接收更变
            hotMatchDetail: [], // 热门
            isShowBetting: false, // 是否显示购物车
            showBettingList: {}, // 显示提交数据
            sportRecordObj: {}, // 投注记录
            sportRecordTabStatus: 0,
            sportSound: WsSportSound,
            defaultSound: Number(HiCache.getCache<number>('defaultSound')) || 1,
            showList: [
                // {
                //     hName: '科罗拉多急流2队',
                //     cName: '洛杉矶银河2队',
                //     hScore: '0',
                //     cScore: '1',
                //     timer: '36:53',
                //     gid: '1',
                // },
                // {
                //     hName: '罗马尼亚',
                //     cName: '乌克兰',
                //     hScore: '1',
                //     cScore: '2',
                //     timer: '46:53',
                //     gid: '3',
                // },
            ],
        };
    },
    getters: {
        // 获取足球推送
        getShowList(state) {
            return state.showList;
        },
        // 获取页面布局
        getSportLayout(state) {
            return state.sportLayout;
        },

        // 获取盘口设置
        getSportHandicap(state) {
            return state.sportHandicap;
        },

        // 获取赔率设置
        getSportOdds(state) {
            return state.sportOdds;
        },

        // 获取足球进球推送
        getSportGoal(state) {
            if (!state.sportBallGoalNotice) {
                return [];
            }
            return state.sportGoal;
        },
        // 获取header滚动条的位置
        getSportHeaderScrollLeft(state) {
            return state.sportHeaderScrollLeft;
        },
        // 获取国家列表
        getCountryList(state) {
            return state.countryList;
        },
        // 获取联盟列表
        getLeagueList(state) {
            return state.leagueList;
        },
        // 获取大厅列表
        getMatchList(state) {
            return state.matchList;
        },
        // 玩法高亮
        getActiveSport(state) {
            return state.activeSport;
        },
        // 购物车数据
        getBettingSport(state) {
            return state.bettingSport;
        },
        // 是否串关
        getBetMode(state) {
            return state.betMode;
        },
        // 串关金额
        getBetModeMoney(state) {
            return state.betModeMoney;
        },
        // 收藏列表
        getCollectList(state) {
            return state.collectList;
        },
        // 冠军收藏列表
        getOutrightCollectList(state) {
            return state.outrightCollectList;
        },
        // 冠军详情列表
        getOutrightList(state) {
            return state.outrightList;
        },
        // 是否接收更变
        getIsShowCompare(state) {
            return state.isShowCompare;
        },
        // 热门
        getHotMatchDetail(state) {
            return state.hotMatchDetail;
        },
        // 是否显示购物车
        getIsShowBetting(state) {
            return state.isShowBetting;
        },
        // 显示提交数据
        getShowBettingList(state) {
            return state.showBettingList;
        },
        // 详情所有玩法
        getActiveMatchAllPlays(state) {
            return (type: number): PlayListType[] => {
                switch (type) {
                    case 0: // 所有
                        return state.activeMatchDetail?.playList ?? [];
                    case 20: // 角球
                        return (state.activeMatchDetail?.playList ?? []).filter(item => item.matchType === 20);
                    case 30: // 罚牌
                        return (state.activeMatchDetail?.playList ?? []).filter(item => item.matchType === 30);
                    default: // 其他
                        return (state.activeMatchDetail?.playList ?? []).filter(item => {
                            const types = item.betPlayType?.split(',')?.map(Number) ?? [];
                            return types.includes(type) && item.matchType === 10;
                        });
                }
            };
        },
    },
    actions: {
        // 设置页面布局
        setShowList(data: any[]) {
            this.showList = data;
        },
        // 设置页面布局
        setSportLayout(layout: WsSportLayout) {
            this.sportLayout = layout;
            HiCache.setCache<WsSportLayout>('sportLayout', layout);
        },

        // 设置盘口设置
        setSportHandicap(handicap: WsSportHandicap) {
            console.log(handicap, 'setSportHandicap');
            this.sportHandicap = handicap;
            this.hotMatchDetail = [];
            HiCache.setCache<WsSportHandicap>('sportHandicap', handicap);
        },

        // 设置赔率设置
        setSportOdds(odds: WsSportOdds) {
            this.sportOdds = odds;
            HiCache.setCache<WsSportOdds>('sportOdds', odds);
        },

        // 设置足球进球推送
        setSportGoal(goal: WsSportGoal[]) {
            this.sportGoal = goal;
            HiCache.setCache<WsSportGoal[]>('sportGoal', goal);

            // 如果没有选择我的收藏赛事和我的投注赛事 则关闭足球进球推送
            this.sportBallGoalNotice = goal.length !== 0;
            HiCache.setCache<boolean>('sportBallGoalNotice', this.sportBallGoalNotice);
        },

        // 设置足球进球推送
        setSportBallGoalNotice(notice: boolean) {
            this.sportBallGoalNotice = notice;
            HiCache.setCache<boolean>('sportBallGoalNotice', notice);

            if (!notice) {
                this.setSportGoal([]);
            } else {
                this.setSportGoal([WsSportGoal.Collect, WsSportGoal.Bet]);
            }
        },

        // 收藏设置
        setCollectList(item: SportListType) {
            let collectId: number[] = [];
            if (HiCache.getCache<string[]>('collectList')) {
                collectId = JSON.parse(HiCache.getCache<string>('collectList'));
            }
            let index = collectId.indexOf(Number(item?.gid));
            if (index > -1) {
                collectId.splice(index, 1);
            } else {
                collectId.push(Number(item?.gid));
            }
            this.collectList = collectId;
            HiCache.setCache<number[]>('collectList', collectId);
        },
        // 冠军收藏设置
        setOutrightList(item: OutrightCollectListType) {
            let outrightId: number[] = [];
            if (HiCache.getCache<string[]>('outrightCollectList')) {
                outrightId = JSON.parse(HiCache.getCache<string>('outrightCollectList'));
            }
            let index = outrightId.indexOf(Number(item?.id));
            if (index > -1) {
                outrightId.splice(index, 1);
            } else {
                outrightId.push(Number(item?.id));
            }
            this.outrightCollectList = outrightId;
            HiCache.setCache<number[]>('outrightCollectList', outrightId);
        },

        // 设置header滚动条的位置
        setSportHeaderScrollLeft(data: number) {
            this.sportHeaderScrollLeft = data;
        },

        //设置selectedSportType
        setSelectedSportType(data: OfficialSportTypeEnumType) {
            this.selectedSportType = data;
        },

        //设置玩法高亮
        setActiveSport(data: any) {
            console.log(data, '666777');
            this.activeSport = data;
        },
        //设置购物车数据
        setBettingSport(data: any) {
            this.bettingSport = data;
        },
        //设置是否串关
        setBetMode(data: number) {
            this.betMode = data;
        },
        // 串关金额
        setBetModeMoney(data: string) {
            this.betModeMoney = data;
        },
        // 可赢金额
        setCanWinMoney(data: number | string) {
            this.canWinMoney = data;
        },
        // 设置接收更变的状态
        setIsShowCompare(data: boolean) {
            this.isShowCompare = data;
        },
        // 是否显示购物车
        setIsShowBetting(data: any) {
            this.isShowBetting = data;
        },
        // 体育设置
        async getFindSportConfig() {
            const userStore = useUserStore();
            let config: sportConfigType;
            if (userStore.IsLogin) {
                if (HiCache.getCache('UserConfig')) {
                    config = HiCache.getCache('UserConfig');
                    this.setConfig(config);
                } else {
                    const res: { data: sportConfigType; code: number } = await findSportConfig();
                    if (res?.code === 0) {
                        HiCache.setCache<sportConfigType>('UserConfig', res?.data);
                        config = res?.data;
                        this.setConfig(config);
                    }
                }
            } else {
                if (HiCache.getCache('defaultConfig')) {
                    config = HiCache.getCache('defaultConfig');
                    this.setConfig(config);
                } else {
                    const res: { data: sportConfigType; code: number } = await findSportConfig();
                    if (res?.code === 0) {
                        HiCache.setCache<sportConfigType>('defaultConfig', res?.data);
                        config = res?.data;
                        this.setConfig(config);
                    }
                }
            }
        },
        // 保存体育设置
        async getSetConfig() {
            let data: sportConfigType = {
                pageType: 1,
                oddsPreferenceType: this.sportOdds,
                footballPushType: this.sportGoal?.join(','),
                handicap: this.sportHandicap === WsSportHandicap.Europe ? 'E' : 'H',
                pushSoundType: this.defaultSound,
            };
            const res = await setConfig(data);
            if (res?.code === 0) {
                HiCache.setCache<sportConfigType>('UserConfig', data);
            }
        },
        setConfig(config: sportConfigType) {
            // 足球推送
            if (config?.footballPushType?.includes(',')) {
                let footballSportGoal: any = config?.footballPushType?.split(',');
                this.setSportGoal(<WsSportGoal[]>footballSportGoal);
            }
            // 赔率变动
            this.setSportOdds(config?.oddsPreferenceType);
            // 盘口设置
            this.setSportHandicap(config?.handicap?.toUpperCase() === 'E' ? WsSportHandicap.Europe : WsSportHandicap.HongKong);
            // 推送声音
            this.setDefaultSound(config?.pushSoundType);
        },
        // 赛果列表
        async getFindResultPage(data: any) {
            return await findResultPage(data);
        },
        // 国家列表
        async getFindCountryList(data: any) {
            const res = await findCountryList(data);
            if (res?.code === 0) {
                this.countryList = res?.data;
            }
            return res;
        },
        // 联盟列表
        async getFindLeagueList(data: any) {
            return await findLeagueList(data);
        },
        // 赛果详情
        async getFindResultDetail(data: any) {
            return await findResultDetail(data);
        },
        // 购物车数据刷新
        async getFindPlayOdds(data: any) {
            return await findPlayOdds(data);
        },
        // 投注订单数据
        updateShowBettingList(data: { billNo: string; itemId: string }[]) {
            if ((<ShowBettingListType>this.showBettingList).betMode === 1) {
                (<ShowBettingListType>this.showBettingList).betItems = (this.showBettingList as ShowBettingListType).betItems?.map(item => {
                    let newItem = data?.find(value => value?.itemId && Number(item?.itemId) === Number(value?.itemId));
                    return {
                        ...item,
                        billNo: newItem?.billNo,
                    };
                });
            } else {
                let newItem = data?.find(value => Number(value?.itemId) === 0);
                (<ShowBettingListType>this.showBettingList).billNo = newItem?.billNo;
            }
        },
        // 结算通知
        updateOrderStatus(data: { billNos: string[]; isChecked: boolean }) {
            if ((<ShowBettingListType>this.showBettingList).betMode === 1) {
                (<ShowBettingListType>this.showBettingList).betItems = (this.showBettingList as ShowBettingListType).betItems?.map(item => {
                    if ((<string[]>data?.billNos)?.some(value => Number(value) === Number(item?.billNo))) {
                        return {
                            ...item,
                            orderStatus: data.isChecked ? 1 : 2,
                        };
                    } else {
                        return item;
                    }
                });
            } else {
                if ((<string[]>data?.billNos)?.some(value => Number(value) === Number((<ShowBettingListType>this.showBettingList)?.billNo))) {
                    (<ShowBettingListType>this.showBettingList).orderStatus = data.isChecked ? 1 : 2;
                }
            }
        },
        // 大厅列表
        async getFindMatchList(params: any, cancelExecutor?: (cancel: () => void) => void) {
            this.matchList = [];
            const res = await findMatchList(params, cancelExecutor);
            const { code, data } = res;
            if (code === 0) {
                const newArr = this.commonHandleMatchList(data);
                this.matchList = newArr;
                return {
                    code,
                    data: newArr,
                };
            } else {
                this.matchList = [];
            }

            return res;
        },

        // 收藏列表
        async getFindFavoritesMatchList(params: any) {
            const res = await findFavoritesMatchList(params);
            const { code, data } = res;
            if (code === 0) {
                const newArr = this.commonHandleMatchList(data);
                this.matchList = newArr;
                return {
                    code,
                    data: newArr,
                };
            } else {
                this.matchList = [];
            }

            return res;
        },

        // 收藏列表
        async getFindChampionFavoritesMatchList(params: any) {
            return await findChampionFavoritesMatchList(params);
        },

        // 大厅赛事列表
        commonHandleMatchList(data: any) {
            const transformData = (data: any[]): HallListType[] => {
                let newArr = data.map((item1: any[]) => ({
                    sportType: item1[0],
                    sportTypeName: item1[1],
                    leagueList: transformLeagueList(item1[2], item1[0], item1[1]),
                }));
                return newArr;
            };

            const transformLeagueList = (data: any[], sportType: number, sportTypeName: string): LeagueListType[] => {
                return (data ?? []).map((item2: any[]) => ({
                    leagueName: item2[0],
                    matchCount: item2[1],
                    sportList: transformSportList(item2[2]),
                    sportType,
                    sportTypeName,
                }));
            };

            const transformSportList = (data: any[]): SportListType[] => {
                return (data ?? []).map((item3: any[]) => ({
                    gid: item3[0],
                    hid: item3[1],
                    cid: item3[2],
                    hName: item3[3],
                    cName: item3[4],
                    hIcon: item3[5],
                    cIcon: item3[6],
                    matchStartTime: item3[7],
                    playCount: item3[8],
                    timer: item3[9],
                    now_score: item3[10],
                    half_score: item3[11],
                    isHalf: item3[12],
                    playList: transformPlayList(item3[13], item3[0]),
                    nowCornerScore: item3[14],
                    nowYellowScore: item3[15],
                    nowRedScore: item3[16],
                    categoryCode: item3[17],
                    nowOvertimeScore: item3[18],
                    status: item3[19],
                }));
            };

            const transformPlayList = (data: any[], gid): PlayListType[] => {
                return (data ?? []).map((item4: any[]) => ({
                    playCode: item4[0],
                    playName: item4[1],
                    oddsList: transformOddsList(item4[2], item4[5]),
                    betPlayTitle: item4[3],
                    matchType: item4[4],
                    gid,
                    is_include_principal: item4[5], // 欧洲盘赔率不变 ,香港盘时 is_include_principal为true 则表示页面显示包含本金,odds不需要-1.否则需要-1
                }));
            };

            const transformOddsList = (data: any[], data2): OddsListType[] => {
                return (data ?? []).map((item5: any[]) => ({
                    playItemCode: item5[0],
                    result: item5[1],
                    itemId: item5[2],
                    odds: item5[3],
                    status: Number(item5[3]) === 0 && Number(item5[4]) === 1 ? 2 : item5[4],
                    oldStatus: item5[4],
                    showTitle: item5[5],
                    betShowTitle: item5[6],
                    compare: 0,
                    is_include_principal: Number(data2 || 0),
                }));
            };
            console.log(transformData(data as any[]), '赛事列表');
            return transformData(data as any[]);
        },

        // 冠军详情数据组装
        commonHandleOutrightList(data: any) {
            const transformData = (data: any[]): OutrightPlayListType[] => {
                let newArr = data.map((item1: any[]) => {
                    return {
                        playCode: item1[0],
                        playName: item1[1],
                        categoryCode: item1[2],
                        playCount: item1[3],
                        oddsList: transformOddsList(item1[4]),
                    };
                });
                return newArr;
            };

            const transformOddsList = (data: any[]): OutrightOddsListType[] => {
                return (data ?? []).map((item5: any[]) => ({
                    itemId: item5[0],
                    playItemCode: item5[1],
                    odds: item5[2],
                    status: Number(item5[2]) === 0 && Number(item5[3]) === 1 ? 2 : item5[3],
                    oldStatus: item5[3],
                    playItemName: item5[4],
                    compare: 1,
                }));
            };
            return transformData(data as any[]);
        },
        // 比赛详情
        async setMatchDetailList(gid: any) {
            try {
                const res = await findMatchDetail(gid);
                const { code, data } = res;

                if (code === 0) {
                    const newObj = transformDetailList(data as any[]);
                    newObj.playList.forEach(item => {
                        item.oddsGroupByList = transformOddsGroupByList(item.oddsList);
                        item.gridStyle = setGridStyle(item.oddsGroupByList);
                    });

                    console.log(newObj, '======================详情页数据');
                    this.activeMatchDetail = newObj;

                    return {
                        code,
                        data: newObj,
                    };
                }

                return res;
            } catch (error) {
                this.activeMatchDetail = {} as any;
                return Promise.reject(error);
            }
        },
        // 投注数据
        async setSubmitData(isSetAutoAcceptOddsType = false) {
            let betItems: betItemsType[] = [];
            let showBetItems: any[] = [];
            if (Array.isArray(this.bettingSport)) {
                this.bettingSport?.forEach(data => {
                    if (this.betMode === 2) {
                        betItems.push({
                            matchType: data?.categoryCode === 3 ? 40 : (data as BettingListTYpe)?.matchType,
                            gid: data?.gid,
                            categoryCode: data?.categoryCode,
                            playCode: data?.playCode,
                            playItemCode: data?.playItemCode,
                            itemId: data?.itemId,
                            odds: data?.odds,
                            sportType: data?.sportType,
                            is_include_principal: (data as BettingListTYpe)?.is_include_principal, // 欧洲盘赔率不变 ,香港盘时 is_include_principal为true 则表示包含本金,odds需要-1.否则不需要-1
                        });
                        showBetItems.push({
                            ...data,
                        });
                    } else {
                        let newCanWinMoney: number | string = 0;
                        if (this.sportHandicap === WsSportHandicap.Europe) {
                            //todo 欧洲盘: 可赢金额为 赔率 * 金额 - 本金
                            newCanWinMoney = toFixedTwoNum(getTimes(data?.money || 0, getMinus(data?.odds, 1)));
                        } else {
                            //todo 香港盘: 可赢金额为 (is_include_principal === true ? (赔率 * 金额 - 本金) : (赔率 * 金额))
                            newCanWinMoney = toFixedTwoNum(getTimes(data?.money || 0, Number((data as BettingListTYpe)?.is_include_principal || 0) > 0 ? getMinus(data?.odds, 1) : data?.odds));
                        }

                        betItems.push({
                            canWinMoney: newCanWinMoney,
                            betMoney: data?.money || 0,
                            matchType: data?.categoryCode === 3 ? 40 : (data as BettingListTYpe)?.matchType,
                            gid: data?.gid,
                            categoryCode: data?.categoryCode,
                            playCode: data?.playCode,
                            playItemCode: data?.playItemCode,
                            itemId: data?.itemId,
                            odds: data?.odds,
                            sportType: data?.sportType,
                            is_include_principal: (data as BettingListTYpe)?.is_include_principal, // 欧洲盘赔率不变 ,香港盘时 is_include_principal为true 则表示包含本金,odds需要-1.否则不需要-1
                        });

                        showBetItems.push({
                            ...data,
                            canWinMoney: newCanWinMoney,
                            orderStatus: Number(data?.categoryCode) === 0 && Number(data?.sportType) === 1 ? 0 : 1,
                        });
                    }
                });
            }

            if (this.betMode === 2) {
                this.showBettingList = {
                    sportType: (showBetItems[0] as betItemsType)?.sportType,
                    autoAcceptOddsType: isSetAutoAcceptOddsType ? '1' : this.sportOdds,
                    betMode: this.betMode,
                    handicap: this.sportHandicap === WsSportHandicap.Europe ? 'E' : 'H',
                    canWinMoney: this.canWinMoney,
                    betMoney: this.betModeMoney,
                    betItems: this.bettingSport,
                    // orderStatus === 1  已确认, === 0 待确认
                    orderStatus: showBetItems?.some(value => Number(value?.categoryCode) === 0 && Number(value?.sportType) === 1) ? 0 : 1,
                };
                return {
                    sportType: betItems[0]?.sportType,
                    autoAcceptOddsType: isSetAutoAcceptOddsType ? '1' : this.sportOdds,
                    betMode: this.betMode,
                    handicap: this.sportHandicap === WsSportHandicap.Europe ? 'E' : 'H',
                    canWinMoney: this.canWinMoney,
                    betMoney: this.betModeMoney,
                    betItems,
                };
            } else {
                this.showBettingList = {
                    sportType: (showBetItems[0] as betItemsType)?.sportType,
                    autoAcceptOddsType: isSetAutoAcceptOddsType ? '1' : this.sportOdds,
                    betMode: this.betMode,
                    handicap: this.sportHandicap === WsSportHandicap.Europe ? 'E' : 'H',
                    betItems: showBetItems,
                };
                return {
                    sportType: betItems[0]?.sportType,
                    autoAcceptOddsType: isSetAutoAcceptOddsType ? '1' : this.sportOdds,
                    betMode: this.betMode,
                    handicap: this.sportHandicap === WsSportHandicap.Europe ? 'E' : 'H',
                    betItems,
                };
            }
        },

        // 今日和早盘联盟
        async getFindLocationLeagueList(data: any,cancelExecutor?: (cancel: () => void) => void) {
            return await findLocationLeagueList(data,cancelExecutor);
        },

        // 冠军列表
        async getFindOutrightLocationList(data: any) {
            return await findOutrightLocationList(data);
        },

        // 冠军赛事列表
        async getFindOutrightLeagueList(data: any) {
            return await findOutrightLeagueList(data);
        },
        // 冠军详情
        async getFindOutrightInfo(params: any) {
            const res = await findOutrightInfo(params);
            const { code, data } = res;
            if (code === 0) {
                const newArr = this.commonHandleOutrightList(data);
                console.log(newArr, '冠军详情');
                this.outrightList = newArr;
                return {
                    code,
                    data: newArr,
                };
            } else {
                this.outrightList = [];
            }
            return res;
        },

        // 具体某个联赛的赛事数据
        async setSingleLeagueList(params: { categoryCode: number; sportType: number; leagueId: number }) {
            const res = await findSingleLeagueList(params);
            const { code, data } = res;
            if (code === 0) {
                const newArr = this.commonHandleMatchList(data);
                console.log(newArr, '<<league MatchList');
                this.singleMatchList = newArr;
                return {
                    code,
                    data: newArr,
                };
            }
            return res;
        },

        // 组装热门赛事列表的逻辑抽离
        transformHotDetailList(data: any[]): HotSportListType[] {
            let hName: string;
            let cName: string;

            const transformDetailPlays = (data: HotSportListType): HotPlayListType => {
                return {
                    playCode: data[0],
                    playName: data[1],
                    is_include_principal: data[2], // 欧洲盘赔率不变 ,香港盘时 is_include_principal为true 则表示包含本金,odds需要-1.否则不需要-1
                    matchType: data[3],
                    oddsList: transformOddsList(data[4], data[2]),
                };
            };

            const transformOddsList = (data: any[], data2: number | boolean): OddsListType[] => {
                return (data ?? []).map((item2: any[]) => {
                    return {
                        playItemCode: item2[0],
                        result: item2[1],
                        itemId: item2[2],
                        is_include_principal: Number(data2 || 0), // 欧洲盘赔率不变 ,香港盘时 is_include_principal为true 则表示页面显示包含本金,item2[8]为odds - 1, item2[3]为odds
                        odds: this.sportHandicap === WsSportHandicap.Europe ? item2[3] : Number(data2 || 0) === 1 ? item2[3] : item2[8],
                        status: Number(item2[3]) === 0 && Number(item2[4]) === 1 ? 2 : item2[4],
                        oldStatus: item2[4],
                        compare: 0, // 0: 相等 1: 大 2: 小
                        betShowTitle: item2[5],
                        showTitle: item2[6]?.replace(/{h}/g, hName)?.replace(/{c}/g, cName),
                        oddsE: item2[8],
                    };
                });
            };

            return data?.map(item => {
                return {
                    gid: item[0],
                    leagueName: item[1],
                    hid: item[2],
                    cid: item[3],
                    hName: item[4],
                    cName: item[5],
                    hIcon: item[6],
                    cIcon: item[7],
                    matchStartTime: item[8],
                    playCount: item[9],
                    playList: transformDetailPlays(item[10]),
                    categoryCode: item[11],
                    sportType: item[12],
                };
            });
        },

        // 热门比赛
        async getFindHotList(cancelExecutor?: (cancel: () => void) => void) {
            try {
                const res = await findHotList(cancelExecutor);
                const { code, data } = res;

                if (code === 0) {
                    const newObj = this.transformHotDetailList(data as any[]);
                    console.log(newObj, '热门赛事');
                    this.hotMatchDetail = newObj;

                    return {
                        code,
                        data: newObj,
                    };
                }

                return res;
            } catch (error) {
                console.log(error, '<error');
            }
        },

        // 投注记录
        async getRecordObj(data: any) {
            try {
                let res: any;

                if (this.sportRecordTabStatus === -1) {
                    res = await findBetRecordAll(data);
                } else {
                    res = await findBetRecordByStatus(data);
                }

                if (res.code === 0) {
                    for (let i in res?.data) {
                        res.data[i]?.records?.forEach((item: IRecordList) => {
                            item.step = -1;
                        });
                    }
                    this.sportRecordObj = res.data;
                    console.log(this.sportRecordObj, 'BetRecordObj');
                }

                return res;
            } catch (error) {
                console.log(error, '<<error');
                this.sportRecordObj = {};
            }
        },
        updateRecordListById(item: IRecordList, index?: string) {
            let list: IRecordList[];
            if (this.sportRecordTabStatus === -1) {
                list = this.sportRecordObj['notSettleList']?.records;
            } else {
                list = this.sportRecordObj['list']?.records;
            }
            const idx = list.findIndex((i: IRecordList) => i.billNo === item.billNo);
            if (idx !== -1) {
                setTimeout(() => {
                    list.splice(idx, 1);
                }, 2000);
            }
        },

        // 投注记录tab值修改
        setSportRecordTabStatus(status: number) {
            this.sportRecordTabStatus = status;
        },

        // 修改默认提示音
        setDefaultSound(data: number) {
            this.defaultSound = data;
            HiCache.setCache<number>('defaultSound', data);
        },
    },
});
